import { render, staticRenderFns } from "./portfolioC.vue?vue&type=template&id=3e97f3fe"
import script from "./portfolioC.vue?vue&type=script&lang=js"
export * from "./portfolioC.vue?vue&type=script&lang=js"
import style0 from "./portfolioC.vue?vue&type=style&index=0&id=3e97f3fe&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports